/**
 * @generated SignedSource<<0d6f6d36c5e6deb86daaae0994b06a99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MultiUploadInputObject = {
  uploads: ReadonlyArray<UploadInputObject>;
};
export type UploadInputObject = {
  id: string;
  metadata: UploadMetadataInputObject;
  storage: string;
};
export type UploadMetadataInputObject = {
  filename: string;
  mimeType: string;
  size: number;
};
export type uploadZone_AccountIngestStartMutation$variables = {
  multiUploadInput: MultiUploadInputObject;
};
export type uploadZone_AccountIngestStartMutation$data = {
  readonly accountIngestStart: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly multiUpload: {
      readonly id: string;
      readonly phase: string | null | undefined;
    } | null | undefined;
    readonly warnings: ReadonlyArray<string>;
  } | null | undefined;
};
export type uploadZone_AccountIngestStartMutation = {
  response: uploadZone_AccountIngestStartMutation$data;
  variables: uploadZone_AccountIngestStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "multiUploadInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "multiUploadInput",
    "variableName": "multiUploadInput"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MultiUpload",
  "kind": "LinkedField",
  "name": "multiUpload",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "warnings",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uploadZone_AccountIngestStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountIngestStartMutationPayload",
        "kind": "LinkedField",
        "name": "accountIngestStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uploadZone_AccountIngestStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountIngestStartMutationPayload",
        "kind": "LinkedField",
        "name": "accountIngestStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7c6df7211e04a344353413cc1e3f869c",
    "id": null,
    "metadata": {},
    "name": "uploadZone_AccountIngestStartMutation",
    "operationKind": "mutation",
    "text": "mutation uploadZone_AccountIngestStartMutation(\n  $multiUploadInput: MultiUploadInputObject!\n) {\n  accountIngestStart(multiUploadInput: $multiUploadInput) {\n    multiUpload {\n      id\n      phase\n    }\n    errors {\n      message\n      id\n    }\n    warnings\n  }\n}\n"
  }
};
})();

(node as any).hash = "89796dcfde26d99eff3fd7e4174d8c1a";

export default node;
